import $ from "jquery";
import PubSub from "pubsub-js";
import "bootstrap-slider";

const SLIDER_FILTER_PREFIX_ID = "filter.slider-";

const updateSliderRangeDiv = function (sliderRangeDiv, slider) {
  const handles = slider.closest(".slider").find(".slider-handle");
  const x = parseInt(handles[0].style.left.replace("%", ""));
  const y = parseInt(handles[1].style.left.replace("%", ""));
  const width = Math.max(x, y) - Math.min(x, y);
  sliderRangeDiv.css("left", Math.min(x, y) + "%");
  sliderRangeDiv.css("width", width + "%");
};

const initWithRoot = function (rootClass) {
  $("." + rootClass + "").each(function () {
    initSliders($(this));
  });
};

const triggerMinEvent = function (slider, name, param1) {
  const value = slider.attr("data-slider-value");
  const jsonValue = JSON.parse(value);
  const newValue = value.replace("[" + jsonValue[0], "[" + param1);

  // neuen min-wert setzen
  slider.attr("data-slider-value", newValue);
  triggerUrlUpdate(slider, newValue);
};

const triggerMaxEvent = function (slider, name, param1) {
  const value = slider.attr("data-slider-value");
  const jsonValue = JSON.parse(value);
  const newValue = value.replace(jsonValue[1] + "]", param1 + "]");

  // neuen max-wert setzen
  slider.attr("data-slider-value", newValue);
  triggerUrlUpdate(slider, newValue);
};

function toggleLoadingSpinner() {
  const spinner = $(".js-active-filter-spinner");
  const hiddenClass = "product-filter__loading--hidden";

  spinner.removeClass(hiddenClass);
}

const triggerUrlUpdate = function (slider, newValue) {
  slider.attr("data-slider-value", newValue);
  newValue = newValue.replace("[", "");
  newValue = newValue.replace("]", "");
  slider.val(newValue);
  slider.trigger("slideStop");
};

const trackEvent = function (slider) {
  const dataSrc = $(slider).closest("[data-tracking-event]");
  const event = dataSrc.data("tracking-event");
  const category = dataSrc.data("tracking-category");
  const action = dataSrc.data("tracking-action");
  const label = dataSrc.data("tracking-label");

  window.dataLayer = window.dataLayer || [];
  const entry = {};
  entry.event = event;
  entry.eventCategory = category;
  entry.eventAction = action;
  entry.eventLabel = label;
  window.dataLayer.push(entry);
};

const initSliders = function ($root) {
  const $sliders = $root.find('input[id^="' + SLIDER_FILTER_PREFIX_ID + '"]');

  $sliders.each(function () {
    const slider = $(this).slider();
    const sliderId = $(this).attr("id");
    const $sliderRangeDiv = slider.closest(".slider").find(".slider-selection");
    const $editMin = $root.find('input[id="min.' + sliderId + '"]');
    const $editMax = $root.find('input[id="max.' + sliderId + '"]');

    const callback = function () {
      trackEvent(slider);
      toggleLoadingSpinner();
    };

    slider.off("slideStop", callback).on("slideStop", callback);

    slider.off("slide").on("slide", function (ev) {
      // das Slide-Event soll die Input-Boxen updaten
      const value = ev.value;
      $editMin.val(value[0]);
      $editMax.val(value[1]);
      slider.val(value[0] + "," + value[1]);
    });

    const callbackMin = function (e) {
      if (e.keyCode === 13) {
        trackEvent(slider);
        triggerMinEvent(slider, "min", $(this).val());
        updateSliderRangeDiv($sliderRangeDiv, slider);
      }
    };

    const callbackMax = function (e) {
      if (e.keyCode === 13) {
        trackEvent(slider);
        triggerMaxEvent(slider, "max", $(this).val());
        updateSliderRangeDiv($sliderRangeDiv, slider);
      }
    };

    $editMin.off("keyup").on("keyup", callbackMin);
    $editMax.off("keyup").on("keyup", callbackMax);
  });
};

export default function RangeSlider() {
  PubSub.subscribe("core.attach", this.attach.bind(this));
}

RangeSlider.prototype = {
  init: function () {
    initWithRoot("filter-input__slider");
  },

  attach: function () {
    initWithRoot("filter-input__slider");
  },
};
